const blocks = document.querySelectorAll(
  '.aside-block:has(.aside-block__expand)',
);
const expandedClass = 'aside-block--expanded';

const isExpanded = (block) => block.classList.contains(expandedClass);
const toggleExpandCollapse = (b) => {
  b.addEventListener('click', () =>
    // @todo on close, do we scroll back up?
    b.classList.toggle(expandedClass, !isExpanded(b)),
  );
};

(() => {
  if (blocks.length > 0) {
    blocks.forEach((b) => toggleExpandCollapse(b));
  }
})();
